import { useEffect, useState } from "react";
import { useCons } from "../context/ConsContext";
import "./index.css";
import InputForm from "./InputForm";
import InputPhone from "./InputPhone";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

/* Options import */

import { insuranceOptions, brands, neededWork } from "./Options";

export default function PopUp() {
  const urlHook = "https://hook.us1.make.com/7hjh9tb1rmw1znooxjanf93ftht9srgl";

  const navigate = useNavigate();
  const { popActive, setPopActive } = useCons();
  const queryParams = new URLSearchParams(window.location.search);

  const valores = {
    1: {
      origen: "GG-Ads",
      fuente: "Mango",
    },
    2: {
      origen: "FB-Ads",
      fuente: "Mango",
    },
    default: {
      origen: "FB-Ads",
      fuente: "Mango",
    },
  };

  const [data, setData] = useState({
    name: "",
    email: "",
    phoneVeri: "",
    telefonoValidado: false,
    carbrand: "",
    year: "",
    insurance: "yes",
    vin: "",
    neededWork: "",
    comment: "",
    authorization: false,
    origen:
      valores[queryParams.get("origen")]?.origen || valores["default"].origen,
    fuente:
      valores[queryParams.get("origen")]?.fuente || valores["default"].fuente,
    medio: queryParams.get("medio"),
    debug: queryParams.get("debug") || 0,
    landing: window.location.origin + window.location.pathname,
    eventid: Date.now(),
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Verificar el tamaño del archivo
    if (file && file.size > 8 * 1024 * 1024) {
      e.target.value = null;
      alert("The weight of the image must be a maximum of 8mb.");
    } else {
      setSelectedFile(file);
    }
  };

  /* Model ID select */

  const [step, setStep] = useState(1);
  const [error, setError] = useState("");

  const checkDataStep = () => {
    if (step === 1) {
      if (!data.carbrand) {
        setError("Verify Car Brand");
        return false;
      }
      if (!data.year) {
        setError("Verify Car Year");
        return false;
      }
      if (!data.neededWork) {
        setError("Verify Needed Work");
        return false;
      }
      setError("");
      return true;
    }
    if (step === 2) {
      if (!data.comment) {
        setError("Verify Comment");
        return false;
      }
      setError("");
      return true;
    }
    if (step === 3) {
      if (!data.name) {
        setError("Verify Name");
        return false;
      }
      if (!data.phoneVeri) {
        setError("Verify Phone");
        return false;
      }
      if (!data.phoneVeri) {
        setError("Verify Phone");
        return false;
      }
      if (!data.email) {
        setError("Verify Email");
        return false;
      }
      if (!data.authorization) {
        setError("Verify Authorization");
        return false;
      }
      setError("");
      return true;
    }
  };

  const stepChange = (e, to) => {
    e.preventDefault();
    if (!checkDataStep()) {
      return false;
    }
    setStep(to);
  };

  const handleChangeInput = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const checkHandler = () => {
    setData({
      ...data,
      authorization: !data.authorization,
    });
  };

  useEffect(() => {
    setStep(1);
  }, [popActive]);

  /* DataLayer Steps */

  useEffect(() => {
    try {
      dataLayer.push({
        event: "StepForm",
        step: `S${step}`,
      });
    } catch (error) {
      console.log(error);
    }
  }, [step]);

  /* Form Submit */
  const [formLoading, setFormLoading] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!checkDataStep()) {
      return false;
    }
    setFormLoading(true);
    setError("");

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    selectedFile && formData.append("selectedFile", selectedFile);
    await axios
      .post(urlHook, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function (response) {
        //Success ----------------------------------------------------
        console.log("Form Success", response);

        try {
          // eslint-disable-next-line no-undef
          gtag("event", "Goal", {
            event_category: `Click Button Form`,
            event_label: "Form",
          });
        } catch (errorC) {
          console.log(errorC);
        }
        try {
          // eslint-disable-next-line no-undef
          fbq("track", "Lead");
        } catch (errorC) {
          console.log(errorC);
        }
        setFormSuccess(true);
        setPopActive(false);
        navigate("/send");
      })
      //End Succes ----------------------------------------------------
      .catch(function (error) {
        //Error ----------------------------------------------------
        setFormLoading(false);
        try {
          // eslint-disable-next-line no-undef
          gtag("event", "Forms", {
            event_category: "Form Error",
            event_label: error,
          });
        } catch (errorC) {
          console.log(errorC);
        }
        console.log(error);
        console.log("Have a problem");
        setError("Have a problem with the sending data");
      });
    //End Error ----------------------------------------------------
  };

  return (
    <AnimatePresence>
      <motion.div
        className={popActive.active ? "containerPop activePop" : "containerPop"}
        initial={{
          opacity: 0,
          transitionEnd: {
            display: "none",
          },
        }}
        animate={
          popActive.active
            ? { opacity: 1, display: "flex" }
            : {
                opacity: 0,
                transitionEnd: {
                  display: "none",
                },
              }
        }
        exit={{
          opacity: 0,
          transitionEnd: {
            display: "none",
          },
        }}
      >
        <div className="overlayPop" onClick={() => setPopActive(false)} />
        <div className="popUp">
          <div className="close" onClick={() => setPopActive(false)}>
            <span></span>
            <span></span>
          </div>
          <div className="containerForm">
            <div className="stepView">
              <div className="step active">
                <span />
                <p>Step 1</p>
              </div>
              <div className={step >= 2 ? "step active" : "step"}>
                <span />
                <p>Step 2</p>
              </div>
              <div className={step >= 3 ? "step active" : "step"}>
                <span />
                <p>Step 3</p>
              </div>
            </div>
            <h2>Free Estimate</h2>
            {step === 1 && (
              <p>Enter your car information to get your estimate.</p>
            )}
            {step === 2 && <p>Describe what you need.</p>}
            {step === 3 && (
              <p>
                Great! Your application is almost ready. Confirm your contact
                details.
              </p>
            )}
            <form
              onSubmit={handleSubmit}
              className={"step" + step + " form"}
              noValidate
            >
              {step === 1 && (
                <motion.div
                  className="flex flexCol"
                  initial={{
                    x: "50%",
                    opacity: 0,
                  }}
                  animate={{
                    x: 0,
                    opacity: 1,
                  }}
                >
                  <InputForm
                    type="select"
                    name="carbrand"
                    placeholder="Car Brand (Required)"
                    handleChangeInput={handleChangeInput}
                    value={data.carbrand}
                    options={brands}
                    error="Should select an option"
                    required={true}
                  />
                  <InputForm
                    type="number"
                    name="year"
                    placeholder="Year (Required)"
                    value={data.year}
                    handleChangeInput={handleChangeInput}
                    error="You should enter a year"
                    maxLength={4}
                    max={new Date().getFullYear()}
                    required={true}
                  />
                  <InputForm
                    type="radio"
                    name="insurance"
                    value={data.insurance}
                    options={insuranceOptions}
                    placeholder="Do you have insurance for this vehicle? (Required)"
                    handleChangeInput={handleChangeInput}
                    error="Should select an option"
                    required={true}
                  />
                  <InputForm
                    type="select"
                    name="neededWork"
                    placeholder="Description of needed work (Required)"
                    handleChangeInput={handleChangeInput}
                    value={data.neededWork}
                    options={neededWork}
                    error="Should select an option"
                    required={true}
                  />
                  <div className="navStep">
                    <button className="btn" onClick={(e) => stepChange(e, 2)}>
                      Next
                    </button>
                  </div>
                </motion.div>
              )}
              {step === 2 && (
                <motion.div
                  className="flex flexCol"
                  initial={{
                    x: "50%",
                    opacity: 0,
                  }}
                  animate={{
                    x: 0,
                    opacity: 1,
                  }}
                >
                  <InputForm
                    type="text"
                    name="vin"
                    placeholder="VIN Number (Optional)"
                    pattern="[^IOQioq]{17}"
                    value={data.vin}
                    handleChangeInput={handleChangeInput}
                    error="You should enter a Vin Number"
                    maxLength={17}
                    required={false}
                  />
                  <InputForm
                    type="textarea"
                    name="comment"
                    placeholder="Add a Comment (Required)"
                    value={data.comment}
                    handleChangeInput={handleChangeInput}
                    error="You should enter a comment"
                    required={true}
                  />
                  <div className="fileAttach">
                    <input
                      type="file"
                      id="imagenInput"
                      name="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="navStep">
                    <button
                      className="buttonForm btnnext"
                      onClick={(e) => stepChange(e, 1)}
                    >
                      Previous
                    </button>
                    <button className="btn" onClick={(e) => stepChange(e, 3)}>
                      Next
                    </button>
                  </div>
                </motion.div>
              )}
              {step === 3 && (
                <motion.div
                  className="flex flexCol"
                  initial={{
                    x: "50%",
                    opacity: 0,
                  }}
                  animate={{
                    x: 0,
                    opacity: 1,
                  }}
                >
                  <InputForm
                    type="text"
                    name="name"
                    placeholder="Name (Required)"
                    value={data.name}
                    handleChangeInput={handleChangeInput}
                    error="You should enter a name"
                    required={true}
                  />
                  <InputPhone data={data} setData={setData} />
                  <InputForm
                    type="email"
                    name="email"
                    value={data.email}
                    placeholder="Email (Required)"
                    handleChangeInput={handleChangeInput}
                    error="You should enter a email"
                    required={true}
                  />
                  <label htmlFor="authorization">
                    <input
                      type="checkbox"
                      id="authorization"
                      name="authorization"
                      checked={data.authorization}
                      onChange={checkHandler}
                      required={true}
                    />
                    By submitting this form, I authorize the workshop to inspect
                    the vehicle and provide a non-binding estimate. This form is
                    a request only, not a repair order.
                  </label>
                  <div className="navStep">
                    <button
                      className="buttonForm btnnext"
                      onClick={(e) => stepChange(e, 2)}
                    >
                      Previous
                    </button>
                    <button
                      className={
                        formLoading
                          ? "buttonForm btn loadBoton"
                          : formSuccess
                          ? "buttonForm btn formSuccess"
                          : "buttonForm btn"
                      }
                      type="submit"
                    >
                      {formLoading
                        ? "Sending..."
                        : formSuccess
                        ? "Thank you!"
                        : "Get Your Estimate"}
                    </button>
                  </div>
                </motion.div>
              )}
            </form>
            {error && (
              <span className="error">
                <svg
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.5474 14.3026L13.8774 1.58262C13.5673 1.09744 13.14 0.698147 12.6349 0.421562C12.1298 0.144976 11.5632 0 10.9874 0C10.4116 0 9.84499 0.144976 9.33992 0.421562C8.83485 0.698147 8.40755 1.09744 8.0974 1.58262L0.427405 14.3026C0.156458 14.7543 0.00919365 15.2693 0.00041668 15.7959C-0.00836029 16.3225 0.12166 16.8422 0.377405 17.3026C0.673084 17.8209 1.10106 18.2514 1.61761 18.55C2.13415 18.8487 2.72073 19.0049 3.3174 19.0026H18.6574C19.2502 19.0089 19.8341 18.8588 20.3503 18.5674C20.8665 18.2759 21.2966 17.8534 21.5974 17.3426C21.8607 16.8774 21.9948 16.3503 21.986 15.8158C21.9773 15.2814 21.8258 14.7589 21.5474 14.3026V14.3026ZM19.8474 16.3526C19.7272 16.5592 19.5528 16.729 19.343 16.8436C19.1333 16.9581 18.8962 17.0131 18.6574 17.0026H3.3174C3.07863 17.0131 2.84152 16.9581 2.63176 16.8436C2.42201 16.729 2.24759 16.5592 2.1274 16.3526C2.03964 16.2006 1.99343 16.0282 1.99343 15.8526C1.99343 15.6771 2.03964 15.5046 2.1274 15.3526L9.8074 2.62262C9.94541 2.44033 10.1238 2.29249 10.3285 2.1907C10.5332 2.08891 10.7588 2.03593 10.9874 2.03593C11.216 2.03593 11.4416 2.08891 11.6463 2.1907C11.851 2.29249 12.0294 2.44033 12.1674 2.62262L19.8374 15.3426C19.9286 15.4949 19.9775 15.6688 19.9793 15.8463C19.9811 16.0238 19.9355 16.1985 19.8474 16.3526V16.3526Z"
                    fill="#4E4FEB"
                  />
                  <path
                    d="M10.9873 15.0026C11.5396 15.0026 11.9873 14.5548 11.9873 14.0026C11.9873 13.4503 11.5396 13.0026 10.9873 13.0026C10.435 13.0026 9.9873 13.4503 9.9873 14.0026C9.9873 14.5548 10.435 15.0026 10.9873 15.0026Z"
                    fill="#4E4FEB"
                  />
                  <path
                    d="M10.9873 6.00256C10.7221 6.00256 10.4677 6.10792 10.2802 6.29546C10.0927 6.48299 9.9873 6.73735 9.9873 7.00256V11.0026C9.9873 11.2678 10.0927 11.5221 10.2802 11.7097C10.4677 11.8972 10.7221 12.0026 10.9873 12.0026C11.2525 12.0026 11.5069 11.8972 11.6944 11.7097C11.8819 11.5221 11.9873 11.2678 11.9873 11.0026V7.00256C11.9873 6.73735 11.8819 6.48299 11.6944 6.29546C11.5069 6.10792 11.2525 6.00256 10.9873 6.00256Z"
                    fill="#4E4FEB"
                  />
                </svg>
                {error}
              </span>
            )}
            {/* <pre style={{ width: "100%", overflowWrap: "break-word" }}>
          <code style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(data)}</code>
        </pre> */}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
